import React from 'react'
import ShopCreate from "../components/Shop/ShopCreate";

const ShopCreatePage = () => {
  return (
    <div className="shop-create-page-shell">
        <ShopCreate />
    </div>
  )
}

export default ShopCreatePage